import gql from 'graphql-tag';

const REPORT_LISTING_MODAL_QUERY_OPERATION_NAME = 'reportListingModalQuery';

const REPORT_LISTING_MODAL_QUERY = gql`
    query ${REPORT_LISTING_MODAL_QUERY_OPERATION_NAME}($context: ContextInput!, $id: ID!) {
        directFeedbackPromptById(context: $context, id: $id) {
            pages {
                title
                elements {
                    __typename
                    ... on DirectFeedbackFormPageElement {
                        __typename

                        ... on DirectFeedbackFieldSet {
                            label
                        }
                        ... on DirectFeedbackFieldSetElement {
                            __typename
                        }
                        ... on EGDSPlainText {
                            text
                            __typename
                        }
                        ... on DirectFeedbackInputField {
                            instructions

                            labelTemplate {
                                __typename
                            }
                            validations {
                                __typename
                            }
                            required

                            placeholder
                        }
                        ... on DirectFeedbackTextArea {
                            errorMessage
                            label
                            name
                            maxRows
                            minRows
                            required
                            leftIcon {
                                description
                                id
                                withBackground
                            }
                            isEditable
                            __typename
                            validations {
                                __typename
                            }
                            instructions
                            labelTemplate {
                                __typename
                            }

                            placeholder
                            ... on EGDSInputField {
                                __typename
                            }
                        }
                    }
                    ... on DirectFeedbackFieldSet {
                        label
                        __typename
                        elements {
                            __typename
                        }
                        __typename
                    }
                    ... on DirectFeedbackInputField {
                        leftIcon {
                            id
                            size
                            theme
                            token
                            __typename
                            withBackground
                        }
                        placeholder
                        rightIcon {
                            id
                            size
                            theme
                            token
                            __typename
                            withBackground
                        }
                        required
                        validations {
                            __typename
                        }
                    }
                    ... on DirectFeedbackRadioGroup {
                        groupName
                        selected
                        options {
                            ... on DirectFeedbackRadioButton {
                                labelSuffix
                                label
                                description
                                disabled
                                value
                            }
                            __typename
                        }
                    }
                }

                __typename
            }
            __typename
        }
    }
`;

export {REPORT_LISTING_MODAL_QUERY_OPERATION_NAME, REPORT_LISTING_MODAL_QUERY};
